module.exports = __webpack_public_path__ + "img/Comic03-3.72370867.png";